export class UssdSubscription {
  id: number;
  extension: number;
  extension_type: number;
  balance: number;
  callback: string;
  active: boolean;
  expires_at: string;
  created_at: string;
  updated_at: string;

  constructor() {
    this.id = 0;
    this.extension = 0;
    this.extension_type = 0;
    this.balance = 0;
    this.callback = '';
    this.active = false;
    this.expires_at = '';
    this.created_at = '';
    this.updated_at = '';
  }
}

export class UssdCode {
  id: number;
  code: string;
  extension: string;
  sessionsUsed: number;
  sessionsAvailable: number;
  callbackUrl: string;
  approvalStatus: string;
  expiresOn: Date;
  created_at: Date;
  updated_at: Date;

  constructor() {
    this.id = 0;
    this.code = '';
    this.extension = '';
    this.sessionsUsed = 0;
    this.sessionsAvailable = 0;
    this.callbackUrl = '';
    this.approvalStatus = '';
    this.expiresOn = null;
    this.created_at = null;
    this.updated_at = null;
  }
}

export class UssdCodeRequest {
  code: string;
  extension: string;
  callbackUrl: string;
  purpose: string;

  constructor() {
    this.code = '';
    this.extension = '';
    this.callbackUrl = '';
    this.purpose = '';
  }
}

export class UssdSubscriptionUpdate {
  callback_url: string;

  constructor() {
    this.callback_url = '';
  }
}

export class UssdPurchase {
  id: number;
  type: string;
  amount: number;
  created_at: string;
  updated_at: string;
  value?: number;
  topup: {
    amount: number;
    completed: number;
    successful: number;
    created_at: string;
    updated_at: string;
  };

  constructor() {
    this.id = 0;
    this.type = '';
    this.amount = 0;
    this.created_at = '';
    this.updated_at = '';
    this.value = 0;
    this.topup = {
      amount: 0,
      completed: 0,
      successful: 0,
      created_at: '',
      updated_at: ''
    };
  }
}

export class UssdSessionHistory {
  current_page: number;
  data: any[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: Array<{
    url: string;
    label: string;
    active: boolean;
  }>;
  next_page_url: string;
  path: string;
  per_page: number;
  prev_page_url: string;
  to: number;
  total: number;

  constructor() {
    this.current_page = 1;
    this.data = [];
    this.first_page_url = '';
    this.from = 0;
    this.last_page = 1;
    this.last_page_url = '';
    this.links = [];
    this.next_page_url = '';
    this.path = '';
    this.per_page = 10;
    this.prev_page_url = '';
    this.to = 0;
    this.total = 0;
  }
}

